const sum = (total, { price, quantity }) => total + price * quantity;

export const getOrderSubtotal = products => {
  if (products && products.length) {
    return products.reduce(sum, 0);
  }

  return 0;
};

const DISCOUNT = {
  unit({ discount: { unitOff }, products }) {
    /*
     * Currently, the DT/MDT only supports one type of product (GAS P-13)
     * so, for now it's ok to user the first product only, because
     * if only 1 type is supported, array has always 1 item
     * and the first index can be used safely
     */
    const productPrice = products[0].price;
    const amountDiscounted = productPrice * unitOff;

    return amountDiscounted;
  },
  percent({ discount: { percentOff }, subtotal }) {
    return (percentOff * subtotal) / 100;
  },
  other({ discount: { amountOff } }) {
    return amountOff;
  },
};

export const getVoucherDiscountTotal = ({ voucher, products, isInAppPayment }) => {
  const isInvalid =
    isInAppPayment || !voucher || !voucher.discount || !products || !products.length;

  if (isInvalid) return 0;

  const subtotal = getOrderSubtotal(products);
  const { discount } = voucher;

  const calculateDiscount = DISCOUNT[discount.type] || DISCOUNT.other;

  const voucherDiscount = calculateDiscount({ discount, subtotal, products });

  return voucherDiscount > subtotal ? 0 : voucherDiscount;
};

export const getOrderTotal = (order, withVoucherDiscount = false) => {
  const subtotal = getOrderSubtotal(order.products);

  const discount = withVoucherDiscount ? getVoucherDiscountTotal(order) : 0;

  return subtotal - discount;
};

export const getOrderTotalForOrderDetails = (order, orderDetails, withDiscounts = false) => {
  const subtotal = getOrderSubtotal(order.products);

  const voucherDiscount = withDiscounts ? orderDetails.voucherDiscount : 0;

  const creditDiscount = withDiscounts ? orderDetails.creditDiscount : 0;

  return subtotal - voucherDiscount - creditDiscount;
};

export default {
  getOrderSubtotal,
  getOrderTotal,
  getOrderTotalForOrderDetails,
  getVoucherDiscountTotal,
};



// WEBPACK FOOTER //
// ../utils/functions/order-values/index.js